module.exports = {
    VP_LEVELS: {
        RESTRICTED: 0,
        NORMAL: 1,
        HIGH: 2,
        VERY_HIGH: 3,
    },

    VP_LEVELS_PARAMETERS: {
        0: { label: 'restrictedVPLevelLabel', value: 'restrictedVPLevelValue' },
        1: { label: 'normalVPLevelLabel', value: 'normalVPLevelValue' },
        2: { label: 'highVPLevelLabel', value: 'highVPLevelValue' },
        3: { label: 'veryHighVPLevelLabel', value: 'veryHighVPLevelValue' },
    },

    RISK_OF_SHORTAGE: {
        VERY_UNLIKELY: 0.2,
        UNLIKELY: 0.5,
        LIKELY: 0.8,
        VERY_LIKELY: 1,
    },

    ALERT_LEVEL_GROUPS: {
        NORMAL: 'normal',
        VIGILANCE: 'vigilance',
        ALERT: 'alerte',
        REINFORCED_ALERT: 'alerte renforcee',
        CRISIS: 'crise',
    },
}